/**
 * 语音页 AI 客户头像用男 / 女哪一张(1025)。此前固定一张女性插画,男声客户也是它。
 *
 * 判定顺序:
 * 1. 场景里管理员显式选了(aiConfig.customerLook)→ 听它的;
 * 2. 预置音色 → 按音色本身的男女声(与 ai 侧 coaching voices 小表同一份 id);
 * 3. 「我的音色」(克隆声纹,不带性别)→ 从人设 / 场景描述里找称谓;
 * 4. 都判不出 → 女(与默认音色「温和女客户」一致,存量行为不变)。
 */
import type { ScenarioAiConfig } from "@/features/coaching/api/coachingService";

export type CustomerLook = "male" | "female";

/** ai app/modules/coaching/infrastructure/voices.py 里的男声 id;其余预置都是女声。 */
const MALE_PRESET_VOICES = new Set(["longshu_v3", "longshuo_v3"]);

const MALE_WORDS =
  /先生|男士|大哥|哥们|大叔|叔叔|大爷|老爷子|小伙|男客户|男性|爸爸|父亲|丈夫|老公|他(?:的|说|想|是)/;
const FEMALE_WORDS =
  /女士|小姐|大姐|姐姐|阿姨|大妈|奶奶|姑娘|女客户|女性|妈妈|母亲|太太|妻子|老婆|宝妈|她(?:的|说|想|是)/;

export function customerLookOf(scene: {
  aiConfig?: ScenarioAiConfig | null;
  customerPersona?: string | null;
  description?: string | null;
}): CustomerLook {
  const cfg = scene.aiConfig;
  if (cfg?.customerLook === "male" || cfg?.customerLook === "female") return cfg.customerLook;
  if (cfg?.voiceProfileId == null) {
    return cfg?.voice && MALE_PRESET_VOICES.has(cfg.voice) ? "male" : "female";
  }
  const text = `${scene.customerPersona ?? ""}\n${scene.description ?? ""}`;
  const male = MALE_WORDS.test(text);
  const female = FEMALE_WORDS.test(text);
  if (male && !female) return "male";
  return "female";
}
